import { Component, OnInit, OnDestroy, OnChanges, Output, Input, ViewChild, ElementRef, EventEmitter } from '@angular/core';

import { IInlineEdit } from '../../inline-edit';

declare var tinymce: any;


export class CustomEditorComponent implements OnInit, OnDestroy, OnChanges, IInlineEdit {

	 public data: string = '';
	 public state: string = 'passive';
	 public fingerprint: string = '';
	 public height = 300;
	 public showActions: boolean = false;
	 public onSave = new EventEmitter<any>();
	 public onChange = new EventEmitter<any>();
	 public onCancel = new EventEmitter<any>();

	 public editorElm: ElementRef;

	public localData: string = '';
	public initialData: string = '';
	public editor: any;

	// Lifecycle Events
	public ngOnInit(): void {
		if (!this.fingerprint) {
			throw 'The "fingerprint" attribute is required!';
		}
		this.initCustomEditor();
	}

	public ngOnDestroy() {
		if (tinymce && this.editor) {
			tinymce.remove(this.editor);
		}
	}

	public ngOnChanges(changes: any): void {
		if (changes.hasOwnProperty('data') && changes['data'].currentValue) {
			this.localData = JSON.parse(JSON.stringify(changes['data'].currentValue));
			this.initialData = JSON.parse(JSON.stringify(changes['data'].currentValue));
		}
	}

	// Events
	public onSaveClick(): void {
		let data = {
			fingerprint: this.fingerprint,
			data: this.editor.getContent()
		};
		this.onSave.next(data);
		this.onChangeStateMode('passive');
	}

	public onCancelClick(): void {
		this.restoreData();
		this.onChangeStateMode('passive');
		this.onCancel.next(this.initialData);
	}

	public onChangeStateMode(state: string): void {
		this.state = state;
		if (this.editor) {
			this.updateEditorContent();
		}
	}

	// Helpers
	private initCustomEditor(): void {
		tinymce.init({
			target: this.editorElm.nativeElement,
			skin: false,
			plugins: ['paste', 'link', 'autoresize', 'lists', 'preview', 'searchreplace', 'wordcount', 'code', 'insertdatetime', 'contextmenu', 'autoresize'],
			width: '100%',
			height: this.height,
			autoresize_min_height: this.height,
			autoresize_max_height: 400,
			branding: false,
			setup: (editor) => {
				this.editor = editor;
				this.editor.on('keyup', (evt, i) => {
					this.localData = editor.getContent();
					if (!this.showActions) {
						this.onChange.next(this.localData);
					}
				});
				this.editor.on('change', (evt, i) => {
					this.localData = editor.getContent();
					if (!this.showActions) {
						this.onChange.next(this.localData);
					}
				});
				this.editor.on('init', (evt, i) => {
					this.updateEditorContent();
				});
			}
		});
	}

	private updateEditorContent(): void {
		this.editor.setContent(this.localData);
	}

	private restoreData(): void {
		this.localData = null;
		this.localData = JSON.parse(JSON.stringify(this.initialData));
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/inline-edit/components/custom-editor/custom-editor.component.ts